var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddgreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 4791,
    transform: "translate(-124 -856)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -124,
    y: -282,
    width: 1366,
    height: 4217,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -17,
    y: -159,
    width: 762,
    height: 192,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    stroke: "#1A875E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6H4",
    stroke: "#2D916B",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8V4",
    stroke: "#2D916B",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 4791,
    fill: "white",
    transform: "translate(-124 -856)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddgreenIcon);
export default __webpack_public_path__ + "static/media/addgreenIcon.a8b7fba30b2c0c8d0c6f562baf54e82e.svg";
export { ForwardRef as ReactComponent };